var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork2Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 46.302C16.8427 45.7426 12.9248 44.0325 9.68819 41.3646C6.45158 38.6967 4.02506 35.1773 2.6825 31.2035C1.33993 27.2298 1.13476 22.9598 2.09015 18.8757C3.04553 14.7915 5.12343 11.0556 8.08934 8.08971C11.0553 5.1238 14.7911 3.04589 18.8753 2.09051C22.9595 1.13513 27.2294 1.3403 31.2032 2.68286C35.1769 4.02543 38.6963 6.45194 41.3642 9.68856C44.0321 12.9252 45.7422 16.843 46.3016 21",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5776 45.842C15.5336 41.378 13.4996 33.266 13.4996 24C13.4996 14.734 15.5336 6.62196 18.5776 2.15796",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49963 22.5H19.4996",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99768 10.5H41.9997",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09558 34.5H16.4996",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4216 2.15796C32.0128 6.53357 33.5902 11.4344 34.0376 16.5",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 46.5C41.1271 46.5 46.4996 41.1274 46.4996 34.5C46.4996 27.8726 41.1271 22.5 34.4996 22.5C27.8722 22.5 22.4996 27.8726 22.4996 34.5C22.4996 41.1274 27.8722 46.5 34.4996 46.5Z",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4996 40.5V28.5H35.9996C36.7953 28.5 37.5583 28.8161 38.121 29.3787C38.6836 29.9413 38.9996 30.7044 38.9996 31.5C38.9996 32.2956 38.6836 33.0587 38.121 33.6213C37.5583 34.1839 36.7953 34.5 35.9996 34.5C36.7953 34.5 37.5583 34.8161 38.121 35.3787C38.6836 35.9413 38.9996 36.7044 38.9996 37.5C38.9996 38.2956 38.6836 39.0587 38.121 39.6213C37.5583 40.1839 36.7953 40.5 35.9996 40.5H31.4996Z",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4996 34.5H35.9996",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 28.5V27",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 40.5V42",
    stroke: "#070811",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2Icon1);
export default __webpack_public_path__ + "static/media/work2-icon1.e97403cba005fc575f441545d466af8d.svg";
export { ForwardRef as ReactComponent };